module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"oma":"Jipii! Valitsit oman kampuksen<br>Oman kampuksen sivulle voit valita mitkä tahansa ravintolat mihin tahansa järjestykseen. Aloita painamalla järjestysnappulaa yllä."},"en":{"oma":"Jipii! You chose a custom campus<br>On this custom campus view you may choose whatever restaurants you want and even order them to your liking. Start by pressing the re-ordering icon above."}}')
  delete Component.options._Ctor
}
